import { useState } from "react";
import styles from "./GlossarSearch.module.scss";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { useGrid } from "@aleksundshantu/aunds-utils-react/primitives/grid";
import { CustomSVG } from "@/components/_primitives/CustomSVG/CustomSVG.client";

interface GlossarSearchProps {
  setActiveLetter: (activeLetter: string) => void;
}

export const GlossarSearch = ({ setActiveLetter }: GlossarSearchProps) => {
  const { getIcon, getLabel } = useGlobalContext();

  const { setItems, setTotalPosts, setCurrentPage } = useGrid();
  const [inputValue, setInputValue] = useState("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setInputValue(event.target.value);
  };
  const onSearch = () => {
    setCurrentPage(1);
    setItems([]);
    setTotalPosts(-1);
    setActiveLetter(inputValue);
  };

  const handleKeyPress = (
    event: React.KeyboardEvent<HTMLInputElement>,
  ): void => {
    if (event.key === "Enter") {
      onSearch();
    }
  };

  return (
    <div className={`${styles["glossar-search"]}`}>
      <div className={styles["search-container"]}>
        <label htmlFor="search" className={styles["search-label"]}>
          {getLabel("glossar_search_label")}
        </label>
        <div className={styles["search-input-wrapper"]}>
          <input
            type="search"
            id="search"
            className={styles["search-input"]}
            placeholder={getLabel("search_placeholder")}
            aria-label={getLabel("search_input_aria_label")}
            autoComplete="off"
            onChange={handleChange}
            onKeyDown={handleKeyPress}
          />
          <button
            aria-label={getLabel("arialabel_glossar_search")}
            type="button"
            className={styles["search-button"]}
            onClick={onSearch}
          >
            <CustomSVG
              width={16}
              height={16}
              src={getIcon("glossarSearch")}
              wrapper={"span"}
              className="is-flex"
              aria-hidden="true"
            />
            <span className={"sr-only"}>Search</span>
          </button>
        </div>
      </div>
    </div>
  );
};
